export const STORE_LOCALE = Symbol("locale");
export const STORE_ADAPTER = Symbol("adapter");
export const STORE_CAMPAIGN = Symbol("campaign");
export const STORE_TRANSFORMERS = Symbol("transformers");
export const STORE_OVERRIDES = Symbol("overrides");
export const STORE_TRIAL_LINKS = Symbol("trialLinks");
export const STORE_FORMATTER = Symbol("formatter");
